'use client';

import React, { Component } from 'react';

import Ciphers from '../reusable-components/layouts-components__rec/ciphers';
import Results from '../reusable-components/layouts-components__rec/results';
import Process from '../reusable-components/layouts-components__rec/process';
import Complex from '../reusable-components/layouts-components__rec/complex';
import Team from '../reusable-components/layouts-components__rec/team';
import Tasks from '../reusable-components/layouts-components__rec/tasks';
import NextProject from '../reusable-components/layouts-components__common-cases/next-project';

import FullWrapper from '../reusable-components/layouts-components__common-cases/full-wrapper';
import MainTitle from '../reusable-components/layouts-components__common-cases/main-title';

import './style.sass';
import Review from '../reusable-components/layouts-components__common-cases/review';
import OfferButton from '../../../../../shared/sections/OfferButton';
import CommonSmallTitle from '../common-components/common-small-title';
import CommonSmallText from '../common-components/common-small-text';
import ScrollAnimation from '../../../../../core/ScrollAnimation';

const gensMainTitle = {
    titleMainText: `Расширение охвата целевой аудитории на&nbsp;рынке поддержки несырьевого экспорта России`,
    titleAnimation: '/images/pic/preview/rec.png',
    subtitleContainer: [
        {
            modeText: 'клиент',
            colorMode: '#14355d',
            nameText: 'АО&nbsp;&laquo;Российский экспортный центр&raquo;',
        },
        {
            modeText: 'Отрасль',
            colorMode: '#14355d',
            nameText: 'Организация несырьевого экспорта',
        },
        {
            modeText: 'Услуги',
            colorMode: '#14355d',
            nameText: 'SEO-продвижение, настройка контекстной и&nbsp;таргетированной рекламы\n',
        },
        {
            modeText: 'Технологии',
            colorMode: '#14355d',
            nameText: 'Яндекс.Директ, Google Ads, Facebook Ads, myTarget',
        },
    ],
};

const nextProjectGens = {
    nextProjectTitle:
        'Помогли Колледжу МИД России собрать в 3 раза больше заявок на поступление абитуриентов',
    nextProjectImg: '/images/pic/preview/mid.png',
    nextProjectLink: '/cases/marketing/mid',
    nextProjectLinkTitle: 'Колледж Министерства иностранных дел Российской Федерации',
    nextProjectText:
        'Обеспечили сбор не менее 500 анкет для каждого потока на поступление в Колледж МИД',
};

const reviewRec = {
    reviewText: `Мы довольны полученным опытом работы и понимаем, что требуются технологические решения для развития проекта. Спасибо команде Вебпрактик, профессиональный взгляд которой позволил нам найти новые точки роста.`,
    reviewAuthors: [
        {
            title: 'Мария Будкова',
            subtitle: 'эксперт по интернет-маркетингу РЭЦ',
        },
    ],
    downLoadPresentationText: '&nbsp; Получить презентацию кейса',
};

class Rec extends Component {
    render() {
        return (
            <section className="Rec">
                <MainTitle MainTitle={gensMainTitle}>
                    <CommonSmallTitle className="rec__subtitle">
                        АО&nbsp;&laquo;Российский экспортный центр&raquo;
                    </CommonSmallTitle>
                    <CommonSmallText>
                        Это государственный институт поддержки несырьевого экспорта, предоставляющий
                        российским экспортерам широкий спектр финансовых и&nbsp;нефинансовых мер
                        поддержки.
                    </CommonSmallText>
                </MainTitle>

                <Tasks />

                <Complex />

                <Process />

                <Results />

                <Ciphers />

                <Team />

                <Review Review={reviewRec} />

                <ScrollAnimation animateIn="zoomIn" offset={50} animateOnce={true} duration={1}>
                    <FullWrapper>
                        <OfferButton linkText="Нанять команду" />
                    </FullWrapper>
                </ScrollAnimation>

                <NextProject NextProject={nextProjectGens} />
            </section>
        );
    }
}

export default Rec;
